(function (angular) {
    'use strict';

    angular.module('app')
        .controller('adminEmailTemplatesController', adminEmailTemplatesController);

    adminEmailTemplatesController.$inject = [
        'modalService',
        'EmailTemplatesApi',
        'queryParams',
        'handleError'
    ];

    function adminEmailTemplatesController(
        modalService,
        EmailTemplatesApi,
        Templates,
        queryParams,
        handleError
    ) {
        var vm = this;

        // properties
        vm.isLoading = false;
        vm.templates = {};
        vm.filters = {
            key: '',
            subject: '',
            page: 1,
            page_size: 15
        };
        vm.editedPendingTemplates = []; // holds the ID's of pending templates, in case they're approved, so we can add a style

        // methods
        vm.getTemplates = getTemplates;
        vm.editTemplate = editTemplate;

        /**
         * Retrieves templates from the api and adds to scope
         * @return {void}
         */
        function getTemplates() {
            vm.isLoading = true;
            EmailTemplatesApi.get(vm.filters, function (response) {
                vm.templates = response;
                vm.isLoading = false;
            }, function (err) {
                handleError(err);
                vm.isLoading = false;
            });
        }

        /**
         * Edits the template via a modal, and updates model in this controller
         * @param  {object} template - template object containing id, status
         * @return {void}
         */
        function editTemplate(template) {

            var modal = modalService.open({
                templateUrl: 'modals/manage-email-template.html',
                controller: 'manageEmailTemplateController',
                controllerAs: 'vm',
                windowClass: 'manage-email-template',
                resolve: {
                    etKey: function () {
                        return template.key;
                    }
                }
            });

            modal.result.then(function (updatedTemplate) {
                // Find and update the template on this page
                angular.forEach(vm.templates.data, function (template, index) {
                    if (template.id === updatedTemplate.id) {
                        if (vm.editedPendingTemplates.indexOf(updatedTemplate.id) !== -1 && updatedTemplate.status === 'approved') {
                            // this template has been changed from pending to approved
                            updatedTemplate.recentlyApproved = true;
                        }

                        vm.templates.data[index] = updatedTemplate;
                    }
                });
            });
        }

        // if ?edit=N is set, show the edit modal
        if (queryParams.edit) {
            editTemplate({id: queryParams.edit});
        }

        getTemplates();
    }

}(angular));
